import { useMemo } from "react";
import { useConceptSnapshot } from "@/hooks/useConceptSnapshot";
import {
  computeRecommendations,
  recsForPhase,
  type WorkflowRecommendation,
} from "@/lib/workflowAdvisor";

/**
 * Advisor recs for the Analyze phase — same engine as Curate's frontier ➤
 * and the Where-am-I overlay. `[0]` drives the overview's Next-step card,
 * its card hiding, and the rail nest's ➤ (see analyzePipelineState.ts).
 */
export function useAnalyzeRecs(
  conceptId: string,
  { debateNeedsRefresh }: { debateNeedsRefresh: boolean },
): WorkflowRecommendation[] {
  const snapshot = useConceptSnapshot(conceptId);
  return useMemo(
    () =>
      snapshot
        ? recsForPhase(
            computeRecommendations({ ...snapshot, debateStale: debateNeedsRefresh }).filter(
              (r) => r.status !== "blocked",
            ),
            "analyze",
          )
        : [],
    [snapshot, debateNeedsRefresh],
  );
}
